import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  requestCount: number = 0;
  private loading: boolean = false;

  constructor() { }

  setLoading(loading: boolean) {
    // console.log('set Loading', loading)
    this.loading = loading;
  }

  getLoading(): boolean {
    // console.log('get Loading', this.loading)
    return this.loading;
  }

  setCounter(){
    this.requestCount++
    // console.log('set reqcount', this.requestCount)
  }
  getCounter(){
    // console.log('get reqcount', this.requestCount)
    return this.requestCount;
  }
}
